export function TableCell(props) {
  return (
    <td nowrap="true" style={props.style}>
      {props.children}
    </td>
  );
}
